//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    mode: {
      default: "default",
      type: "string",
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      setTimeout(() => (this.isVisible = isVisible), 400);
    },
  },
};
